module.exports = __webpack_public_path__ + "img/1486497855.74469dae.jpg";